export default __webpack_public_path__ + "static/client_logo_stanford-92076454441cb59c4779352b9335440c.svg";